import React, {useContext,useState, useRef} from 'react';
import {
  Grid,
  TextInput,
  Select,
  SelectItem,
  Button,
  Modal,
  Column,
  DatePickerInput,
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableSelectRow,
  DatePicker
} from 'carbon-components-react';
import {ThemeContext} from '../../context/ThemeProvider';
import {getListHeaderDocAll,getListMailNameEmployeeByKey,postDelegatedUser,postMassiveAction, getDelegationList} from '../../services/services';
import MessageModal from '../MessageModal/MessageModal';
import SessionController from '../../components/FrontSessionController/SessionController';

const TableMenu = ({rowsSelectedFromAllInvoiceTableCallback, getAllDocumentsCallback3,processDocsResponseCallback}) => {

  const MESSAGE_SELECT_A_DOCUMENT_FIRST = 'Please select at least one document';    
  const MESSAGE_SUCCESSFULL_REQUEST = 'Request Successful';

  const [ctrycode, setCtrycode] = useState("");
  const [inputKey, setInputKey] = useState("");
  const [days, setDays] = useState(10);

  //start useState for modal search of employees
  const [masiveReassignModal, setMasiveReassignModal] = useState(false);
  const [findApproverModal, setFindApproverModal] = useState(false);
  const [employeeKeyToSearch,setEmployeeKeyToSearch] = useState('');
  const [employeesList, setEmployeesList] = useState([]);
  const [employeeToSearchSelected, setEmployeeToSearchSelected] = useState('');

  //start useState for modal massive approval
  const [masiveApproveModal, setMasiveApproveModal] = useState(false);

  //start useState for modal delegate
  const [delegateModal, setDelegateModal] = useState(false);
  const [countryEmployeeToDelegate, setCountryEmployeeToDelegate] = useState('613');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  //start useState for cancel delegation modal
  const [cancelDelegationModal, setCancelDelegationModal] = useState(false);
  const [delegationList, setDelegationList] = useState([]);
  const [rowsSelectedFromCancelDelegation,setRowsSelectedFromCancelDelegation] = useState([]);

  // start useState for message modal controllers
  const [messageResponse, setMessageResponse] = useState('');
  const [messageModal, setMessageModal] = useState('');

  const processingRequest = useRef(false);

  const [messageSessionLost, setMessageSessionLost] = useState('');
  
  const theme = useContext(ThemeContext);
  const countriesList = theme.theme.countriesList;
  const profileName = theme.theme.profile;
  const userType = theme.theme.userType;

  const delegationTableHeader = [    
    {
      key:'toUser',
      header:'Delegated To'
    },
    {
      key:'country',
      header:'Country Code'
    }
  ]

  const handleChangeCtrycode = (e) => {    
    setCtrycode(e.target.value); 
  }
  const handleChangeDays = (e) => {
    setDays(e.target.value);
  }
  const handleChangeInputKey = (value) => {
    setInputKey(value);
  }
  const getDocuments = async (key) => {
    
    let daysBeforeToRequest = 0;
    let ctrycodeToRequest = '';
    let keyToRequest = key;
    if(key === 'pais'){      
      if(ctrycode === undefined || ctrycode === '' || ctrycode === 'placeholder-item'){
        openMessageModal('You need to choose a country');
        return;        
      }else{
        daysBeforeToRequest = days;
        ctrycodeToRequest = ctrycode;
      }
    }else if(key === 'query'){
      if(inputKey === ''){
        openMessageModal('The field can not be left empty');
        return;
      }
      daysBeforeToRequest = 0;
      ctrycodeToRequest = inputKey
    }else{
      daysBeforeToRequest = 0;
      ctrycodeToRequest = '';
    }
    if(isRequestActive(true)){
      return;
    }  
    await getListHeaderDocAll(ctrycodeToRequest,daysBeforeToRequest,keyToRequest)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            processDocsResponseCallback(response)         
          })
      }
    })    
    isRequestActive(false);  
  }

  const isRequestActive = (enable) => {
    if(enable){
      if(processingRequest.current){
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;      
      return false;
    }else{
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  //start controller reassing modal
  const openMassiveReassignModal = () => {
    setMasiveReassignModal(true);
  };
  
  const closeMassiveReassignModal = () => {
    setMasiveReassignModal(false);
  };
  const confirmMassiveReassignModal = () => {
    setMasiveReassignModal(false);
    setFindApproverModal(true);
  };
  
  const closeFindApproverModal = () => {
    setFindApproverModal(false);
  };

  const searchEmployeeData = async () => {
    await getEmployeeData();
  }

  const getEmployeeData = async () => {
    let request = {};
    request.clave = employeeKeyToSearch;
    await getListMailNameEmployeeByKey(request)
    .then(response => {
      if(response.status === 200) {
        response.json()
          .then(response => {            
            setEmployeesList(response);
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(response => {
            closeFindApproverModal();            
            openMessageModal(response)
          })
        }
      })    
  }

  const masiveReassing = async () => {
    closeFindApproverModal()
    let request = {};
    if(employeeToSearchSelected.startsWith('Select'))
      return;
    let idDocList = getIdDocListSelected();
    
    if(idDocList == ''){
      openMessageModal(MESSAGE_SELECT_A_DOCUMENT_FIRST);
      return;
    }
        
    request.ids = idDocList;
    request.accion = 'Reassign'
    request.to = employeeToSearchSelected;
    
    if(isRequestActive(true)){
      return;
    }
    await postMassiveAction(request)
    .then(response => {  
      if(response.status === 200){        
        response.text()
        .then(response => {
          openMessageModal(response)
        })      
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } 
    })
    isRequestActive(false)
    getAllDocumentsCallback3();
  }

  //start controller massive approval modal
  const closeMassiveApproveModal = () => {
    setMasiveApproveModal(false);
  }

  const openMassiveApproveModal = () => {
    setMasiveApproveModal(true);
  }

  //start controller error modal
  const openMessageModal = (response) => {
    setMessageResponse(response);
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);
    setMessageResponse('');
  }

  const submitMassiveApproveModal = async () => {
    closeMassiveApproveModal();
    let request = {};
    let idDocList = getIdDocListSelected();
    if(idDocList == ''){
      openMessageModal(MESSAGE_SELECT_A_DOCUMENT_FIRST);
      return;
    }
    request.ids = idDocList;
    request.accion = 'Approve';
    request.to = '';
    
    if(isRequestActive(true)){
      return;
    }

    await postMassiveAction(request)
    .then(response => {   
      if(response.status === 200) {
        response.text()
        .then(response => {
          openMessageModal(response)
        })      
      } else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }   
    })
    getAllDocumentsCallback3();
    isRequestActive(false)
  }

  const getIdDocListSelected = () => {
    let idDocList = '';
    rowsSelectedFromAllInvoiceTableCallback.map((e) => {
      e.cells.map((cell) => {
        if(cell.id.includes('idDoc'))
          idDocList+=cell.value + ";";
      })
    })
    return idDocList;
  }

  //start controller cancel delegate modal
  const closeCancelDelegationModal = () => {
    setCancelDelegationModal(false);
  }

  const openCancelDelegationModal = () => {
    getDelegeations();
    setCancelDelegationModal(true);
  }

  const submitCancelDelegationModal = async () => {
    let request = [];
    let inside = {};
    if(rowsSelectedFromCancelDelegation.length == 0)
      return;
    rowsSelectedFromCancelDelegation.map((row) => {
      row.cells.map((cell) => {
        if(cell.id.includes('country')){
          inside.country = cell.value;          
        }
      })
      inside.borrar = true;
      inside.tipo = 'delegacion';
      request.push(inside);
    })

    if(isRequestActive(true)){
      return;
    }
    await postDelegatedUser(request)
    .then(response => {
      if(response.status === 200) {
        setRowsSelectedFromCancelDelegation([]);
        openMessageModal(MESSAGE_SUCCESSFULL_REQUEST)
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(response => {
            openMessageModal(response)
          })
      }
    })
    isRequestActive(false)
    closeCancelDelegationModal();
  }

  const handleCheckBoxSelected = (row,e) => {
    let newRowsSelectedFromCancelDelegation = [...rowsSelectedFromCancelDelegation];
    let elementPosition = newRowsSelectedFromCancelDelegation.map(element => element.id).indexOf(row.id);
    if(elementPosition == -1){
      newRowsSelectedFromCancelDelegation.push(row);
    }else{
      newRowsSelectedFromCancelDelegation.splice(elementPosition,1);
    }
    setRowsSelectedFromCancelDelegation(newRowsSelectedFromCancelDelegation);
  }

  const getDelegeations = async () =>{
    await getDelegationList()
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response=> {        
            let newResponse = addIdToresponse(response);
            setDelegationList(newResponse.lDelegations);            
          })
      }else{
        response.text()
          .then(response => {
            closeFindApproverModal();            
            openMessageModal(response)
          })
      }
    })
  }

  const addIdToresponse = (response) => {
    response.lDelegations.map((row,id) => {
      row.id = id;
    })
    return response;
  }

  //start controll delegate modal
  const closeDelegateModal = () => {
    setDelegateModal(false)
  }

  const openDelegateModal = () => {
    setDelegateModal(true)
  }

  const submitDelegateModal = async () => {
    closeDelegateModal();
    let request = [];
    let inside = {};

    inside.country = countryEmployeeToDelegate;
    inside.borrar = false;
    inside.tipo = 'delegacion';
    inside.country = countryEmployeeToDelegate;
    inside.toUser = employeeToSearchSelected;
    inside.fechaDesde = startDate;
    inside.fechaHasta = endDate;
    request.push(inside);

    if(isRequestActive(true)){
      return;
    }
    await postDelegatedUser(request)
    .then(response => {
      if(response.status === 200) {
        openMessageModal(MESSAGE_SUCCESSFULL_REQUEST)
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(response => {
            openMessageModal(response)
          })
      }
    })
    isRequestActive(false)
  }
  
  const setDatesOnStates = (dates) => {
    let newDates = [...dates];
    let startDate = newDates[0];
    let endDate = newDates[1];
    if(startDate != undefined){
      startDate = startDate.toISOString();
      startDate = startDate.substring(8,10) + '/' + startDate.substring(5,7) + '/' + startDate.substring(0,4);
      setStartDate(startDate);
    }
    if(endDate != undefined){
      endDate = endDate.toISOString();
      endDate = endDate.substring(8,10) + '/' + endDate.substring(5,7) + '/' + endDate.substring(0,4);
      setEndDate(endDate);
    }
  }

  return (
    <>
      {(userType == 'privilegedUser' || userType == 'viewer') &&
      <>
        <Grid className="table-menu">
          <Column className="flex-container" md={4}>
            <p className="select-label">Country</p>
            <Select
              className="table-menu-select"
              labelText=""
              onChange={handleChangeCtrycode}
              size="md"
            >
               <SelectItem value="placeholder-item" text="Choose a Country"/>            
              {            
                countriesList.map((country) => (
                  <SelectItem value={country.countryCode} text={country.countryName} />
                ))
              }
            </Select>
          </Column>
          <Column className="flex-container" md={3}>
            <p className="select-label">Days</p>
            <Select className="table-menu-select" labelText="" 
              onChange={handleChangeDays}
              defaultValue='10'
              size="md" 
            >
              <SelectItem text="10" value="10"></SelectItem>
              <SelectItem text="30" value="30"></SelectItem>
              <SelectItem text="60" value="60"></SelectItem>
              <SelectItem text="90" value="90"></SelectItem>
              <SelectItem text="120" value="120"></SelectItem>
              <SelectItem text="240" value="240"></SelectItem>
              <SelectItem text="500" value="500"></SelectItem>
              <SelectItem text="1000" value="1000"></SelectItem>
            </Select>
          </Column>
          <Column className="flex-container" md={2}>
            <Button className="table-menu-button" size='sm' id='idButtonAllDocuments' onClick={() => getDocuments('pais')}>All Documents</Button>
            <Button className="table-menu-button" size="sm" id='idButtonMyDocuments' onClick={() => getDocuments('user')}>My Documents</Button> 
          </Column>      
        </Grid>    
        <Grid className="table-menu">      
          <Column className="flex-container" md={6}>
            <TextInput id="text-input-1" type="text" onChange={(e) => handleChangeInputKey(e.target.value)} placeholder="Advanced search" size="md"/>
            <Button className="table-menu-button" onClick={() => getDocuments('query')} size="sm">Get Documents</Button>
          </Column>     
        </Grid>    
      </>
      }
      <>
        {(userType == 'user' || userType == 'viewer') &&        
          <Grid className="table-menu">
            <Column className="flex-container" md={4}>
              <Button className="table-menu-button" onClick={openDelegateModal}>Delegate</Button>
              <Button className="table-menu-button" onClick={openCancelDelegationModal}>Cancel Delegation</Button>
              <Button className="table-menu-button" onClick={openMassiveApproveModal}>Massive Approval</Button>
              <Button className="table-menu-button" onClick={openMassiveReassignModal}>Massive Reassign</Button>
            </Column>
          </Grid>
        }
        <Modal
          className="massiveReassign-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Massive Reassign modal"
          modalAriaLabel="Massive Reassign modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeMassiveReassignModal}
          onRequestSubmit={confirmMassiveReassignModal}
          onSecondarySubmit={closeMassiveReassignModal}
          open={masiveReassignModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Ok"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Please, confirm:</strong></p>}
        >
          <div>
            <p>
            This action will <strong>reassign</strong> all the selected documents if the documents do not need additional actions.
            </p>
          </div>
        </Modal>
        <Modal
          className="findApprover-modal"          
          hasscrollingcontent="false"          
          aria-label="Find Approver modal"
          modalAriaLabel="Find Approver modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeFindApproverModal}
          onRequestSubmit={masiveReassing}
          onSecondarySubmit={closeFindApproverModal}
          open={findApproverModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Ok"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Please, in order to find a employees put name or email data</strong></p>}
        >
          <Grid className="grid-on-modal">            
            <Column lg={6}>
              <TextInput id="text-input-1" type="text" 
                onChange={(e) => setEmployeeKeyToSearch(e.target.value)} placeholder="Find Approver" labelText="" />
            </Column>
            <Column sm={2}>
              <Button size="md" onClick={searchEmployeeData} className="">Find</Button>
            </Column>
            <Column sm={4}>
              <Select id={'find-approver'} helperText="" labelText="" onChange={(e) => setEmployeeToSearchSelected(e.target.value)}>
                <SelectItem label="Select Approver" value="placeholder-item" />
                {employeesList.map((row) => (
                  <SelectItem text={row.name.trim() +' => '+ row.mail.trim()} value={row.mail.trim()} />
                ))
                }
              </Select>
            </Column>
          </Grid>
        </Modal>
        <Modal
          className="massiveApproval-modal"          
          hasscrollingcontent="false"          
          aria-label="Massive Approve modal"
          modalAriaLabel="Massive Approve modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeMassiveApproveModal}
          onRequestSubmit={submitMassiveApproveModal}
          onSecondarySubmit={closeMassiveApproveModal}
          open={masiveApproveModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Ok"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>You are approving the reception of the goods and services and you are responsible of the reception of the goods:</strong></p>}
        >
          <div>
            <p>
            This action will <strong>approve</strong> all the selected documents if the documents do not need additional actions.
            </p>
          </div>
        </Modal>
        <Modal
          className="delegate-modal"          
          hasscrollingcontent="false"          
          aria-label="Delegate modal"
          modalAriaLabel="Delegate modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeDelegateModal}
          onRequestSubmit={submitDelegateModal}
          onSecondarySubmit={closeDelegateModal}
          open={delegateModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Submit"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel=''
        >
          <Grid className="grid-on-modal grid-center-onmodal">  
            <Column sm={4}>
              <label >Select a country to delegate</label>
              <Select labelText="" 
                onChange={(e) => setCountryEmployeeToDelegate(e.target.value)}>                
                {countriesList.map((country) => (
                  <SelectItem value={country.countryCode} text={country.countryName} />
                ))}
              </Select>
                    
            </Column>
          </Grid>
          <Grid className="grid-on-modal grid-center-onmodal">  
            <Column lg={7}>
            <label >Find Approver</label>
              <TextInput id="text-input-1" type="text" labelText=""
                onChange={(e) => setEmployeeKeyToSearch(e.target.value)} placeholder="Find Approver"/> 
            </Column>
            <Column sm={2}>
              <br></br>
              <Button size="md" onClick={searchEmployeeData} className="">Find</Button>
            </Column>            
          </Grid>
          <Grid className="grid-on-modal grid-center-onmodal">
            <Column lg={7}>
              <Select helperText="" labelText="" onChange={(e) => setEmployeeToSearchSelected(e.target.value)}>
                <SelectItem label="Select Approver" value="placeholder-item" />
                {employeesList.map((row) => (
                  <SelectItem text={row.name.trim() +' => '+ row.mail.trim()} value={row.mail.trim()} />
                ))
                }
              </Select>
            </Column>
          </Grid>

          <Grid className="grid-on-modal grid-center-onmodal">
            <Column lg={7}>
              <DatePicker datePickerType="range" onChange={(e) => setDatesOnStates(e)} dateFormat='d/m/Y'>
                <DatePickerInput id="date-picker-input-id-start"                  
                  placeholder="dd/mm/yyyy" labelText="Start date" size="md"/>
                <DatePickerInput id="date-picker-input-id-finish"                   
                  placeholder="dd/mm/yyyy" labelText="End date" size="md" />
              </DatePicker>
            </Column>
          </Grid>
          
        </Modal>
        <Modal
          className="cancelDelegation-modal"          
          hasscrollingcontent="false"          
          aria-label="Cancel Delegation modal"
          modalAriaLabel="Cancel Delegation modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeCancelDelegationModal}
          onRequestSubmit={submitCancelDelegationModal}
          onSecondarySubmit={closeCancelDelegationModal}
          open={cancelDelegationModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Ok"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Cancel Delegation</strong>: <br/>Select the delegation you would like to cancel.</p>}
        >
          <Grid>
          <Column md={16} lg={16}>
            <DataTable
              
              rows={delegationList}
              headers={delegationTableHeader}
              render={({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getTableProps,                
                getSelectionProps
              }) => (
                <TableContainer className={"style-table-unit-info"}>
                  <Table {...getSelectionProps()} useZebraStyles>
                    <TableHead>
                      <TableRow>
                        {<TableHeader />}
                        {headers.map(header => (
                          
                          <TableHeader {...getSelectionProps({ header })}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, id) => (
                        <TableRow {...getRowProps({ row })}>
                          <TableSelectRow  {...getSelectionProps({ row })} onChange={(e) => handleCheckBoxSelected(row,e)}/>
                          {row.cells.map((cell) => (
                            <TableCell key={id} >{cell.value}</TableCell>
                          ))}
                      </TableRow>                        
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            />
          </Column>
          </Grid>
        </Modal>
        <MessageModal messageCallback={messageResponse} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
        <SessionController messageLostSessionCallback={messageSessionLost} />
      </>
      
    </>
  );
};

export default TableMenu;